const DARK_MODE = {
  DARK: "dark",
  LIGHT: "light",
  SYSTEM: "system",
};

export default DARK_MODE;
